import ContentCategory from '@/helpers/contentCategory';

export default {
  SET_ENROLLMENT_CONTEXT(state, context) {
    state.context = context;
  },
  SET_SELECTED_TOPIC(state, topic) {
    state.selectedTopic = topic;
  },
  CLEAR_STUDENT_SELECTED_TOPIC(state) {
    state.selectedTopic = {};
  },
  BEFORE_DESTROY_STUDENT_VIEW(state) {
    state.context = {};
    state.selectedTopic = {};
  },
  UPDATE_TASK_ATTEMPTS(state, attemptData) {
    const index = state.selectedTopic.children && state.selectedTopic.children.findIndex(e => e.id === attemptData.topicId);

    if (index > -1) {
      state.selectedTopic.children[index].content.attempts = [attemptData.attempt, ...state.selectedTopic.children[index].content.attempts];
      state.selectedTopic.children[index].content.config = attemptData.config;
      if (attemptData.expectedAnswer) {
        state.selectedTopic.children[index].content.expectedAnswer = (attemptData.expectedAnswer);
      }
    } else {
      state.selectedTopic.content.attempts = [attemptData.attempt, ...state.selectedTopic.content.attempts];
      state.selectedTopic.content.config = attemptData.config;
      if (attemptData.expectedAnswer) {
        state.selectedTopic.content.expectedAnswer = (attemptData.expectedAnswer);
      }
    }
  },
  UPDATE_QUIZ_ATTEMPT_ANSWER(state, { attemptsData, topicId }) {
    let topic = state.selectedTopic;

    if (state.selectedTopic.categoryTypeId === ContentCategory.ORGANIZATION) {
      topic = state.selectedTopic.children.find((item) => item.id === topicId);
    }

    topic.content.attempts = attemptsData;
  },
  UPDATE_QUIZ_CONTENT(state, { content, topicId }) {
    let topic = state.selectedTopic;

    if (state.selectedTopic.categoryTypeId === ContentCategory.ORGANIZATION) {
      topic = state.selectedTopic.children.find((item) => item.id === topicId);
    }

    topic.content = content;
  },
  ADD_NEW_ATTEMPT_TO_QUIZ(state, topicId) {
    let topic = state.selectedTopic;

    if (state.selectedTopic.categoryTypeId === ContentCategory.ORGANIZATION) {
      topic = state.selectedTopic.children.find((item) => item.id === topicId);
    }

    const lastAttempt = topic.content.attempts[topic.content.attempts.length - 1];

    topic.content.attempts.push({
      answers       : [],
      attemptId     : null,
      attemptNumber : (lastAttempt && lastAttempt.attemptNumber + 1) || 1,
      finishedAt    : null,
      startedAt     : null
    });
  },
  ADD_ATTEMPT_WHEN_QUIZ_EXPIRED_AND_STUDENT_NOT_ANSWERED(state, topicId) {
    let topic = state.selectedTopic;

    if (state.selectedTopic.categoryTypeId === ContentCategory.ORGANIZATION) {
      topic = state.selectedTopic.children.find((item) => item.id === topicId);
    }

    const lastAttempt = topic.content.attempts[topic.content.attempts.length - 1];
    topic.content.attempts = [];

    topic.content.attempts.push({
      answers: [{
        answeredAt   : topic.content.deadlineAt,
        cancelAt     : null,
        isCorrect    : false,
        optionId     : 0,
        questionId   : 0,
        quizAnswerId : 0
      }],
      attemptId     : null,
      attemptNumber : (lastAttempt && lastAttempt.attemptNumber + 1) || 0,
      finishedAt    : topic.content.deadlineAt,
      startedAt     : null
    });
  },
  SET_TOPIC_VIEWED_ON_SELECTED(state, { topicId, viewed }) {
    let topic = state.selectedTopic;

    if (state.selectedTopic.categoryTypeId === ContentCategory.ORGANIZATION && state.selectedTopic.id !== topicId) {
      topic = state.selectedTopic.children.find(item => item.id === topicId);
    }

    if (topic) {
      topic.viewed = viewed;
    }
  }
};
